import React from 'react';

const CookiePolicy = () => {
  return (
    <div className="text-gray-900">
      <h1 className="mb-1 text-xl font-semibold md:text-2xl">Cookie Policy</h1>

      <section className="space-y-4 text-sm leading-6 text-gray-800">
        <p>
          We use cookies and similar technologies to operate the Platform, remember preferences,
          analyse usage, and improve services. Some cookies are essential; others are optional.
        </p>

        <div>
          <h2 className="mb-1 font-semibold">Types</h2>
          <p>
            Essential (authentication, security), functional (preferences), analytics, and, where
            applicable, performance.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">Controls</h2>
          <p>
            You can manage cookies in your browser settings and, where provided, in‑app preferences.
            Blocking essential cookies may impact functionality.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">Third Parties</h2>
          <p>
            Trusted providers may set cookies to deliver services (e.g., analytics). Their policies
            apply.
          </p>
        </div>

        <div>
          <h2 className="mb-1 font-semibold">Contact</h2>
          <p>
            411 Group of Investments (Pty) Ltd
            <br />
            P O Box 99 Lentswe-le-Moriti, Tuli Block, Botswana
            <br />
            Email: info@411group.co.bw
          </p>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
